/**
 * Canonical `rcm_service_code` values for app-level team queue goals, metrics, and shell embeds.
 * Aligns with AgenticRCM `SERVICE_PORTS` keys and Analytics iframe `serviceId` (see Analytics.jsx getServiceAnalyticsUrl).
 */

/** Stable snake_case codes stored in DB / APIs */
export const RCM_SERVICE_CODE = {
  DENIAL_MANAGEMENT: 'denial_management',
  CLAIMS_PROCESSING: 'claims_processing',
  CHARGE_CAPTURE: 'charge_capture',
  INSURANCE_VERIFICATION: 'insurance_verification',
  PRIOR_AUTHORIZATION: 'prior_authorization',
  AR_POSTING: 'ar_posting',
  REMITTANCE_ADVICE: 'remittance_advice',
  CONTRACT_MANAGEMENT: 'contract_management',
  PATIENT_BILLING: 'patient_billing',
  EDI_PLATFORM: 'edi_platform',
};

/**
 * Analytics sidebar / iframe service id → rcm_service_code
 * (matches keys in getServiceAnalyticsUrl servicePortMap in Analytics.jsx)
 */
export const ANALYTICS_SERVICE_ID_TO_RCM_CODE = {
  eligibility: RCM_SERVICE_CODE.INSURANCE_VERIFICATION,
  priorAuth: RCM_SERVICE_CODE.PRIOR_AUTHORIZATION,
  charges: RCM_SERVICE_CODE.CHARGE_CAPTURE,
  claims: RCM_SERVICE_CODE.CLAIMS_PROCESSING,
  arPosting: RCM_SERVICE_CODE.AR_POSTING,
  denial: RCM_SERVICE_CODE.DENIAL_MANAGEMENT,
  patientBilling: RCM_SERVICE_CODE.PATIENT_BILLING,
  ediPlatform: RCM_SERVICE_CODE.EDI_PLATFORM,
  clearingHouse: RCM_SERVICE_CODE.EDI_PLATFORM,
  remittanceAdvice: RCM_SERVICE_CODE.REMITTANCE_ADVICE,
  contractManagement: RCM_SERVICE_CODE.CONTRACT_MANAGEMENT,
};

/** Tab id used by embedded service analytics SPAs for Team Analytics */
export const TEAM_ANALYTICS_TAB_ID = 'team-analytics';

/**
 * Services shown on AgenticRCM top-level Analytics → Team analytics section.
 * `available`: embedded iframe loads; false = placeholder until that service ships the tab + metrics.
 */
export const TEAM_ANALYTICS_EMBED_REGISTRY = [
  {
    sidebarServiceId: 'denial',
    label: 'Denials & Appeals',
    rcmServiceCode: RCM_SERVICE_CODE.DENIAL_MANAGEMENT,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'claims',
    label: 'Claims Processing',
    rcmServiceCode: RCM_SERVICE_CODE.CLAIMS_PROCESSING,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'charges',
    label: 'Charge Management',
    rcmServiceCode: RCM_SERVICE_CODE.CHARGE_CAPTURE,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'eligibility',
    label: 'Insurance Verification',
    rcmServiceCode: RCM_SERVICE_CODE.INSURANCE_VERIFICATION,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'priorAuth',
    label: 'Prior Authorization',
    rcmServiceCode: RCM_SERVICE_CODE.PRIOR_AUTHORIZATION,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'arPosting',
    label: 'AR Posting',
    rcmServiceCode: RCM_SERVICE_CODE.AR_POSTING,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'remittanceAdvice',
    label: 'Remittance Advice',
    rcmServiceCode: RCM_SERVICE_CODE.REMITTANCE_ADVICE,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'contractManagement',
    label: 'Contract Management',
    rcmServiceCode: RCM_SERVICE_CODE.CONTRACT_MANAGEMENT,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
  {
    sidebarServiceId: 'patientBilling',
    label: 'Patient Billing',
    rcmServiceCode: RCM_SERVICE_CODE.PATIENT_BILLING,
    tab: TEAM_ANALYTICS_TAB_ID,
    available: true,
  },
];
